
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-53c9fd4e&scoped=true!postcss-loader!sass-loader?sourceMap!import-glob-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./event-grid.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015&babelrc=false!import-glob-loader!component-example-dir-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./event-grid.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-53c9fd4e!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./event-grid.vue"),
  /* scopeId */
  "data-v-53c9fd4e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/components/organisms/event-grid/event-grid.vue
// module id = 252
// module chunks = 4